import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import ScanTimeoutError from "../errors/scan-timout-error";
import TokensExpiredError from "../errors/tokens-expired-error";
import GeneralApiErrorResponse from "../responses/general-api-error-response";
import ScanAbortedErrorResponse from "../responses/scan-aborted-error-response";
import ScanTimeoutErrorResponse from "../responses/scan-timeout-error-response";
import TokenExpiredErrorResponse from "../responses/token-expired-error-response";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";

export const triggerScanAndGetServers = (
  updateServerListsInStoreFunction,
  signal,
) => {
  return fetch(`${appUrl()}/api/trigger-scan-and-get-servers`, {
    method: "POST",
    headers: buildAuthenticationHeaders(),
    body: JSON.stringify({
      ...buildAuthenticationBody(),
    }),
    signal,
  })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else if (
          json.message ===
          "Request Timeout - Scan did not complete within the expected time"
        ) {
          throw new ScanTimeoutError(
            "Request Timeout - Scan did not complete within the expected time",
          );
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        updateServerListsInStoreFunction(data);
      }
    })
    .catch((err) => {
      if (err instanceof TokensExpiredError) {
        return new TokenExpiredErrorResponse();
      } else if (err instanceof DOMException) {
        return new ScanAbortedErrorResponse();
      } else if (err instanceof ScanTimeoutError) {
        return new ScanTimeoutErrorResponse();
      } else {
        return new GeneralApiErrorResponse();
      }
    });
};
